import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { csrThemeQueryKey } from "./useGetAllCsrTheme";

export function useCsrThemeDelete() {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/steering/csr_themes/" + id);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries([csrThemeQueryKey]),
    });

    return query;
}
